import React, { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform, useMotionTemplate } from "motion/react";
import { cn } from "../utils/motionutils";


export const CardEffect = ({ translateDepth = 10, rotateDepth = 4.5, className, children }) =>{

    const mainRef = useRef(null);
    const x_axis = useMotionValue(0);
    const y_axis = useMotionValue(0);

    const xSpring = useSpring(x_axis);
    const ySpring = useSpring(y_axis);

    const rotateX = useTransform(xSpring, [-0.5, 0.5], [`-${rotateDepth}deg`, `${rotateDepth}deg`]);
    const rotateY = useTransform(ySpring, [-0.5, 0.5], [`-${rotateDepth}deg`, `${rotateDepth}deg`]);
    const translateX = useTransform(xSpring, [-0.5, 0.5], [`-${translateDepth}px`, `${translateDepth}px`]);
    const translateY = useTransform(ySpring, [-0.5, 0.5], [`-${translateDepth}px`, `${translateDepth}px`]);

    const glareX = useTransform(xSpring, [-0.5, 0.5], [0, 100]);
    const glareY = useTransform(ySpring, [-0.5, 0.5], [0, 100]);

    const glareBackground = useMotionTemplate`radial-gradient(circle at ${glareX}% ${glareY}%, rgba(255, 255, 255, 0.9) 10%, rgba(255, 255, 255, 0.75) 20%, rgba(255, 255, 255, 0) 80%)`;

    const handleOnMouseMove = (e) =>{
        if(!mainRef.current) return;

        const rect  = mainRef.current.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;

        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const xPct = mouseX / width - 0.5;
        const yPct = mouseY / height - 0.5;

        x_axis.set(xPct);
        y_axis.set(yPct);

    }

    const handleOnMouseLeave = () => {

        x_axis.set(0);
        y_axis.set(0);
    }


    return(
        <>
        <div className={cn("perspective-distant transform-3d", className)}>
            <motion.div
                ref={mainRef}
                onMouseMove={handleOnMouseMove}
                onMouseLeave={handleOnMouseLeave}
                initial={{scale:1, z:0}}
                whileHover={{scale:1.07, z:50, transition:{duration:0.3}}}
                style={{
                    rotateX,
                    rotateY,
                    translateX,
                    translateY,
                    boxShadow: "rgba(0, 0, 0, 0.01) 0px 520px 146px 0px, rgba(0, 0, 0, 0.04) 0px 333px 133px 0px, rgba(0, 0, 0, 0.26) 0px 83px 83px 0px, rgba(0, 0, 0, 0.29) 0px 21px 46px 0px"
                }}
                className="relative h-full custom-gradient-services rounded-2xl"
            >
                {children}
                <motion.div
                    className="rounded-2xl pointer-events-none absolute inset-0 z-50 h-full w-full mix-blend-overlay"
                    style={{ background: glareBackground, opacity: 0.6 }}
                    transition={{ duration: 0.3}}
                />
            </motion.div>
        </div>
        
        </>
    );

}